import React from "react"
import Container from './container';
import Text from './text';

interface HeaderProps {
  pageSubHeader?: string;
  pageHeader: string;
  backgroundUrl?: string;
  className?: string;
  overlayClassName?: string;
  overlay?: any;
}

const PageHeader: React.FC<HeaderProps> = ({
  pageSubHeader = 'category',
  pageHeader = 'header',
  backgroundUrl = '/assets/images/telesoft-page-header.jpg',
  className = `bg-gradient-to-b from-telesoft to-transparent mix-blend-soft-light`,
  overlayClassName,
  overlay = null,
}) => {
  return (
    <div
      className="group flex justify-center p-6 md:p-10 2xl:p-8 bg-black relative bg-no-repeat bg-center bg-cover"
      style={{
        backgroundImage: `url(${backgroundUrl})`,
      }}
    >
      <div className={`absolute inset-0 ${className} ${overlayClassName} `} />

      {overlay && overlay}
      <div className="w-full relative z-10 py-10 md:py-14 lg:py-20 xl:py-24 2xl:py-32">
        <Container className="px-4">
          <div className="w-full flex flex-col justify-start items-start float-left">
            <h5 className="text-left text-white/50 block">{pageSubHeader}</h5>

            <div className="h-[1px] bg-white group-hover:max-w-[140px] max-w-lg w-full my-3 transition-all duration-300" />

            <Text variant="pageHeading" className="text-white text-left">
              {pageHeader}
            </Text>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default PageHeader;
